import React from "react";
import { Text, View } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { CommonButton } from "../../common/CommonButton";
import GoLiveHeaderSkeleton from "../skeleton-components/GoLiveHeaderSkeleton";

const GoLiveHeader = ({ styles }) => {
  const deviceSize = useDeviceSize();

  return (
    <View
      style={[
        styles.deviceflexDirection,
        {
          marginHorizontal: 15,
        },
      ]}
    >
      {deviceSize === DEVICE_SIZES.XS ||
      deviceSize === DEVICE_SIZES.SM ? null : (
        <View
          style={[
            styles.deviceflexDirection,
            {
              gap: 10,
              alignSelf: "center",
              marginVertical: 10,
              marginLeft: 35,
              marginRight: 50,
            },
          ]}
        >
          <CommonButton
            title="Stream settings"
            onTap={() => {
              // navigateToScreen(navigation, AppScreens.LiveStreaming);
            }}
            buttonStyle={[
              styles.btnStartStream,
              {
                padding: 10,
              },
            ]}
            textStyle={[AppFontStyle.REGULAR_ANYBODY_12, {}]}
          />
        </View>
      )}

      <View
        style={[
          styles.deviceflexDirection,
          {
            gap: 10,
            alignSelf: "center",
            marginVertical: 10,
          },
        ]}
      >
        <View style={{ flexDirection: "row", columnGap: 10 }}>
          <View style={styles.innerView}>
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_14,
                {
                  color: AppColors.gray_C3C3C3,
                  flex: 1,
                  alignSelf: "center",
                },
              ]}
            >
              CPU
            </Text>
            <Text
              style={[
                deviceSize === DEVICE_SIZES.XL
                  ? AppFontStyle.REGULAR_ANYBODY_24
                  : AppFontStyle.REGULAR_ANYBODY_20,
                {},
              ]}
            >
              23.54%
            </Text>
          </View>
          <View style={styles.innerView}>
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_14,
                {
                  color: AppColors.gray_C3C3C3,
                  flex: 1,
                  alignSelf: "center",
                },
              ]}
            >
              Memory
            </Text>
            <Text style={[AppFontStyle.REGULAR_ANYBODY_24, , {}]}>2.54%</Text>
          </View>
          <View style={styles.innerView}>
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_14,
                {
                  color: AppColors.gray_C3C3C3,
                  flex: 1,
                  alignSelf: "center",
                },
              ]}
            >
              Uploading
            </Text>
            <Text style={[AppFontStyle.REGULAR_ANYBODY_24, , {}]}>2kb/s</Text>
          </View>
        </View>
        <View style={{ flexDirection: "row", columnGap: 10 }}>
          <View style={styles.innerView}>
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_14,
                {
                  color: AppColors.gray_C3C3C3,
                  flex: 1,
                  alignSelf: "center",
                },
              ]}
            >
              frame drop
            </Text>
            <Text style={[AppFontStyle.REGULAR_ANYBODY_24, , {}]}>0</Text>
          </View>
          <View style={styles.innerView}>
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_14,
                {
                  color: AppColors.gray_C3C3C3,
                  flex: 1,
                  alignSelf: "center",
                },
              ]}
            >
              FBs
            </Text>
            <Text style={[AppFontStyle.REGULAR_ANYBODY_24, , {}]}>30</Text>
          </View>
        </View>
      </View>
    </View>
  );
};

export default GoLiveHeader;
